module.exports = __webpack_public_path__ + "static/media/delete.a9d4ae9c.svg";